var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15 2.4974C4.15 3.64823 3.225 4.58073 2.08333 4.58073C0.941667 4.58073 0.0166667 3.64823 0.0166667 2.4974C0.0166667 1.3474 0.941667 0.414062 2.08333 0.414062C3.225 0.414062 4.15 1.3474 4.15 2.4974ZM4.16667 6.2474H0V19.5807H4.16667V6.2474ZM10.8183 6.2474H6.67833V19.5807H10.8192V12.5816C10.8192 8.68989 15.8433 8.37156 15.8433 12.5816V19.5807H20V11.1382C20 4.57156 12.565 4.81073 10.8183 8.04323V6.2474Z",
    fill: "#192830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c0f7411358ec6ef8f5a52642c76ee2c9.svg";
export { ForwardRef as ReactComponent };